import { errors } from '@ocean/ui'
import rootRoutes from 'routing/routes'

const { ApplicationError: OceanApplicationError } = errors

const ApplicationError: React.FC = () => <OceanApplicationError backUrl={rootRoutes.root} />

export default ApplicationError
